import React from 'react'
import { Icon } from 'semantic-ui-react'

import BaseDashboardTile from '../Base/BaseDashboardTile'

import { styles } from './styles'

export const LocationsTile = ({ linkTo = '/locations' }) => {
  return (
    <BaseDashboardTile
      icon={<Icon name={'map marker alternate'} style={styles.icon} />}
      title='Find a Location'
      text='Find an Enlyt Health location in your neighborhood.'
      linkTo={linkTo}
      linkText='Search >'
    />
  )
}
